{
    "account": "Účet",
    "add_bookmark": "Túto správu uložiť medzi záložky",
    "add_date": "Pridať dátum",
    "ago": "{{duration}} späť",
    "api_key": "Kľúč API",
    "are_you_sure": "Si si istý ?",
    "ask_delete_message": "Odstráňte túto správu?",
    "audio_not_ready": "Audio ešte nie je pripravený.",
    "bookmark_added": "Kniha správ.",
    "bookmark_removed": "Správa záložka odstránená.",
    "bookmarks": "záložky",
    "cancel_write": "Chcete naozaj zrušiť vytváranie nového príspevku?",
    "cancel": "Zrušiť",
    "changed_group_name": "zmenil názov skupiny",
    "confirm_password_placeholder": "potvrdiť heslo",
    "connect": "Pripojenie",
    "create_a_group": "Vytvoriť skupinu",
    "create_the_group": "Vytvoriť skupinu",
    "daily": "Denne",
    "default_group": "Predvolenú skupinu",
    "delete": "Zmazať",
    "destroy_account_explain": "Potom, čo vymažete svoj účet, nie je tam žiadny návrat. Prosím, uistite sa.",
    "destroy_account": "Odstráňte svoj účet",
    "edit": "Upraviť",
    "email": "E-mail",
    "email_input": "Vyplňte svoju e-mailovú adresu tu",
    "empty_message": "Správa je prázdna a nie je možná.",
    "error": "Chyba",
    "error_new_message": "Pri odosielaní vašej správy došlo k chybe.",
    "error_upload": "Objavila sa chyba počas odosielania",
    "forgot_password": "Zabudli ste heslo?",
    "group_left": "Opustili ste skupinu.",
    "group_share_choice": "Ktoré skupiny chcete poslať túto správu?",
    "groups": "Skupiny",
    "group_updated": "Skupina bola aktualizovaná.",
    "has_commented_on": "komentoval",
    "has_joined": "sa pripojil k",
    "has_left": "opustil",
    "has_posted_in": "zverejnila v",
    "hourly": "Každú hodinu",
    "in": "v",
    "Invalid login/password": "Nesprávny login alebo heslo",
    "invitation_link": "Pozývací odkaz",
    "invitation_welcome": "Vitajte na Zusam. Prosím, prihláste sa pred vstupom do skupiny.",
    "just_now": "Práve teraz",
    "lang": "jazyk",
    "login_input": "Zvoľ si nejaké prihlasovacie meno",
    "login_placeholder": "e-mail",
    "login": "Prihlásiť sa",
    "logout": "Odhlásiť sa",
    "mark_all_as_read": "označiť všetko ako prečítané",
    "monthly": "Mesačne",
    "multiple_photos_upload": "Objavila sa chyba. Skúste priložiť obrázky po jednom (táto chyba sa môže objavovať v niektorých prehliadačoch)",
    "name_input": "Zvoľ si nejaké meno",
    "name": "Meno",
    "new_password_placeholder": "nové heslo",
    "next_coms": "Pozri nasledujúce komentáre",
    "none": "Žiadne",
    "notification_emails": "E-mailové upozornenia",
    "notification_emails_stopped": "E-mailové upozornenia zastavili!",
    "notifications": "oznámenia",
    "parent_message": "Správa rodiča",
    "password": "Heslo",
    "password_input": "Tu napíš heslo",
    "password_placeholder": "heslo",
    "password_reset_mail_sent": "Pozrite sa na e-mail na obnovenie hesla v schránke.",
    "passwords_dont_match": "Heslá sa nezhodujú",
    "previous_coms": "Pozri predchádzajúce komentáre",
    "public_link": "verejné spojenie",
    "publish_in_group": "publikovať v skupine",
    "quit_group": "Opustiť skupinu",
    "remove_bookmark": "Zrušte označenie tejto správy",
    "replies_one": "{{count}} odpoveď",
    "replies_other": "{{count}} odpovedí",
    "reply": "odpoveď",
    "reset_api_key": "Obnovte kľúč rozhrania API (budete odpojení)",
    "reset_invitation_link": "Obnoviť pozvánku odkaz",
    "reset_password_title": "Zmena hesla",
    "save_changes": "Uložiť zmeny",
    "search_in_group": "hľadať v tejto skupine",
    "search_without_result": "Vaše vyhľadávanie nezhodla žiadne správy.",
    "settings": "Nastavenia",
    "settings_updated": "Vaše nastavenia boli zmenené",
    "share_message": "zdieľajte správu",
    "signup": "Prihlásiť",
    "submit": "Odoslať",
    "text_placeholder": "Tu napíš príspevok",
    "the_message_from": "správa od",
    "title_placeholder": "Nadpis vášho príspevku (nie je povinné)",
    "to": "na",
    "upload_audio": "Pridajte zvukový súbor.",
    "upload_image": "Pridať fotografie",
    "upload_music": "Pridať hudbu",
    "upload_pdf": "Pridať PDF",
    "upload_video": "Pridajte video",
    "User not found": "Neexistujúci užívateľ",
    "users": "užívatelia",
    "video_not_ready": "Video ešte nie je pripravené.",
    "weekly": "Týždenne"
}
